<template lang="html">
  <div class="footer">
      <p>浙江和云网络科技有限公司   电话： 0571-87156686</p>
      <p>地址：中国浙江省杭州市西湖区转塘街道之江发展大厦204室   备案号：<a href="https://beian.miit.gov.cn" target="_blank">浙ICP备18024148号-2</a></p>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped="">
.footer{
    border-top: 1px solid #e6e6e6;
    background: #fafafa;
    width: 100%;
    height: 80px;
    padding-top: 20px;
    // line-height: 80px;
    color: #757575;
    font-size: 12px;
    text-align: center;
}

.footer a {
    color: #757575;
    text-decoration: none;
}

.footer a:hover {
    text-decoration: none;
}
</style>
